import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Metrics from "@/components/Metrics";
import Manifesto from "@/components/Manifesto";
import Testimonials from "@/components/Testimonials";
import LeadForm from "@/components/LeadForm";
import Footer from "@/components/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-obsidian text-ivory min-h-screen" data-testid="app-root">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Metrics />
        <Manifesto />
        <Testimonials />
        <LeadForm />
      </main>
      <Footer />
    </div>
  );
}
